<template>
  <div class="fixed bottom-0 right-0 bg-blue-600 z-50 p-2 rounded-tl-lg">
    <svg
      style="height: 25px; width: 25px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 238.5249 220.4923"
    >
      <g>
        <path
          d="M143.782,57.453a80.5649,80.5649,0,0,1-23.58,57.0525,1.3775,1.3775,0,0,1-1.9415.0006A80.79,80.79,0,0,1,118.261.4a1.3775,1.3775,0,0,1,1.9415.0006A80.5646,80.5646,0,0,1,143.782,57.453Z"
          style="fill: #fff"
        />
        <path
          d="M237.966,132.4154a1.375,1.375,0,0,1,.126,1.8361,80.9558,80.9558,0,0,1-73.9457,30.2452,49.5052,49.5052,0,0,1,14.77,15.46,50.178,50.178,0,0,1,2.556,4.7973,1.3585,1.3585,0,0,1-.9985,1.9024,49.8039,49.8039,0,0,1-42.5472-13.02.6022.6022,0,0,0-.08-.08,48.9191,48.9191,0,0,1-5.15-5.74,37.6372,37.6372,0,0,1-7.07-19.13q-.12-1.5-.12-3.03a37.1621,37.1621,0,0,1,.24-4.25c.04-.39.1-.79.15-1.18.04-.28.08-.56.13-.84a77.41,77.41,0,0,1,1.79-8.48,80.3657,80.3657,0,0,1,20.91-36.22c.65-.65,1.31-1.28,1.97-1.9A80.5625,80.5625,0,0,1,207.54,71.0385a1.3756,1.3756,0,0,1,1.3426,1.3652,60.9944,60.9944,0,0,1-5.8556,26.163q-1.0958,2.34-2.41,4.62a61.5709,61.5709,0,0,1-21.17,21.76,49.7982,49.7982,0,0,1,58.5194,7.4688Z"
          style="fill: #fff"
        />
        <path
          d="M94.36,201.84c0-5.1509,2.7834-9.8139,7.28-13.192.345-.2382.6781-.4757,1.0112-.7139a61.9307,61.9307,0,0,0,16.1076-17.1953.556.556,0,0,1,.9487.0006,61.74,61.74,0,0,0,16.0966,17.1947c.3331.2382.6662.4757,1.0112.7139,4.4966,3.3781,7.28,8.0411,7.28,13.192,0,10.3018-11.1344,18.6525-24.862,18.6525C105.4944,220.4923,94.36,212.1416,94.36,201.84Z"
          style="fill: #fff"
        />
        <path
          d="M.4185,132.4154a1.3751,1.3751,0,0,0-.1259,1.8361,80.9558,80.9558,0,0,0,73.9457,30.2452,49.5067,49.5067,0,0,0-14.77,15.46,50.2231,50.2231,0,0,0-2.556,4.7973,1.3585,1.3585,0,0,0,.9986,1.9024,49.8044,49.8044,0,0,0,42.5472-13.02.5963.5963,0,0,1,.08-.08,48.9281,48.9281,0,0,0,5.15-5.74,37.64,37.64,0,0,0,7.07-19.13q.12-1.5.12-3.03a37.1621,37.1621,0,0,0-.24-4.25c-.04-.39-.1-.79-.15-1.18-.04-.28-.08-.56-.13-.84a77.4108,77.4108,0,0,0-1.79-8.48,80.3645,80.3645,0,0,0-20.91-36.22c-.65-.65-1.31-1.28-1.97-1.9A80.5626,80.5626,0,0,0,30.8449,71.0385a1.3756,1.3756,0,0,0-1.3426,1.3652,60.9944,60.9944,0,0,0,5.8556,26.163q1.0957,2.34,2.41,4.62a61.57,61.57,0,0,0,21.17,21.76A49.7987,49.7987,0,0,0,.4185,132.4154Z"
          style="fill: #fff"
        />
      </g>
    </svg>
  </div>

  <div class="item px-3 py-1">
    <div class="headline flex flex-row justify-between items-center">
      <h2 class="text-xl sm:text-2xl font-semibold pb-5 pt-5 text-blue-600">
        <div class="flex flex-col">
          <span class="page-type text-sm sm:text-base">Order</span>
          Order #{{ order.reference_number }}
        </div>
      </h2>

      <a
        v-if="wooCommerceGotoUrl"
        href="#"
        @click.prevent="gotoWooCommerce()"
        class="rounded-full bg-blue-600 p-3"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="#ffffff"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </a>
    </div>
    <!-- END Order header -->

    <!-- Order tabs -->
    <div class="tabs">
      <dl class="mb-5 grid grid-cols-2 rounded-lg bg-gray-100 shadow divide-x divide-gray-400">
        <div
          v-for="item in stats"
          :key="item.name"
          class="px-4 py-5 sm:p-6"
        >
          <dt class="text-base font-semibold text-blue-600">
            {{ item.name }}
          </dt>
          <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
            <div class="flex items-baseline text-2xl font-semibold text-blue-600">
              {{ item.stat }}
              <span
                v-if="item.previousStat"
                class="ml-2 text-sm font-medium text-gray-600"
              >
                from {{ item.previousStat }}
              </span>
            </div>

            <div
              v-if="item.change && item.changeType"
              :class="[
                item.changeType === 'increase' ? 'bg-green-200 text-green-800' : 'bg-red-100 text-red-800',
                'inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0'
              ]"
            >
              <ArrowSmUpIcon
                v-if="item.changeType === 'increase'"
                class="-ml-1 mr-0.5 shrink-0 self-center h-5 w-5 text-green-400"
                aria-hidden="true"
              />
              <ArrowSmDownIcon
                v-else
                class="-ml-1 mr-0.5 shrink-0 self-center h-5 w-5 text-red-400"
                aria-hidden="true"
              />
              <span class="sr-only"> {{ item.changeType === 'increase' ? 'Increased' : 'Decreased' }} by </span>
              {{ item.change }}
            </div>
          </dd>
        </div>
      </dl>

      <PageTabGroup>
        <PageTabList>
          <PageTab label="Details" />
          <PageTab label="Items" />
          <PageTab label="Fulfillment" />
          <PageTab label="Payment" />
        </PageTabList>

        <PageTabPanels>
          <PageTabPanel>
            <div class="border-b border-gray-400 pb-3 mb-3">
              <h3 class="text-lg leading-6 font-semibold text-blue-600">Order Details</h3>
            </div>

            <div>
              <div>
                <dl class="grid grid-cols-1 gap-3">
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Order #:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.id }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Status:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.display_status }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Location:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.location_name }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Origin:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.origin }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Origin ID:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.source_id || '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Delivery Method:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.display_delivery_method }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Subtotal:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.subtotal ? _dollars(order.subtotal) : '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Discount:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.total_discount ? _dollars(order.total_discount) : '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Discount Name:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.discount_name ? _dollars(order.discount_name) : '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Total Refund:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.total_refund ? _dollars(order.total_refund) : '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Refund Reason:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.refund_reason ?? '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Total:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.total ? _dollars(order.total) : '-' }}
                    </dd>
                  </div>
                </dl>

                <div class="border-b border-gray-400 pb-3 mb-3 mt-5">
                  <h3 class="text-lg leading-6 font-semibold text-blue-600">Customer Details</h3>
                </div>
                <dl class="grid grid-cols-1 gap-3">
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Email</dt>
                    <dd class="text-gray-900 font-semibold">
                      <span>
                        {{ order.customer?.email || '-' }}
                      </span>
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Name</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.customer?.first_name || '' }} {{ order.customer?.last_name || '' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Phone</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.customer?.phone || '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Allotment Used</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.medical?.allotment_used ? order.medical?.allotment_used + ' g' : '-' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Has Loyalty</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.customer?.has_loyalty ? 'Yes' : 'No' }}
                    </dd>
                  </div>
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Veteran</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.customer?.is_veteran ? 'Yes' : 'No' }}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </PageTabPanel>

          <PageTabPanel>
            <div class="border-b border-gray-400 pb-3 mb-3">
              <h3 class="text-lg leading-6 font-semibold text-blue-600">Items</h3>
            </div>

            <data-table
              :items="order.items"
              :headers="['Product', 'Price', 'Quantity', 'Subtotal', 'Discount', 'Total', 'Refunded']"
              :actions="[]"
              :selectable="false"
            >
              <template v-slot:rows="slotRow">
                <order-item-index-row
                  v-slot:rows="slotRow"
                  v-bind="slotRow"
                  :selectable="false"
                />
              </template>
            </data-table>
          </PageTabPanel>

          <PageTabPanel>
            <div class="sm:grid sm:grid-cols-1 sm:gap-10">
              <DeliveryInfo
                v-if="order.is_delivery"
                :shipping="order.shipping || {}"
              ></DeliveryInfo>
              <div v-else>
                <div class="border-b border-gray-400 pb-3 mb-3">
                  <h3 class="text-lg leading-6 font-semibold text-blue-600">Fulfillment Details</h3>
                </div>
                <dl class="sm:divide-y sm:divide-gray-200">
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Delivery Method:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.display_delivery_method }}
                    </dd>
                  </div>
                </dl>
                <dl class="sm:divide-y sm:divide-gray-200">
                  <div class="flex flex-col">
                    <dt class="font-medium text-blue-600 pr-1">Location:</dt>
                    <dd class="text-gray-900 font-semibold">
                      {{ order.location?.name || 'NA' }}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </PageTabPanel>

          <PageTabPanel>
            <div>
              <div class="border-b border-gray-400 pb-3 mb-3">
                <h3 class="text-lg leading-6 font-semibold text-blue-600">Payment</h3>
              </div>

              <data-table
                :items="order.payments"
                :headers="['Type', 'Method', 'Amount', 'Paid At']"
                :actions="[]"
                :selectable="false"
              >
                <template v-slot:rows="slotRow">
                  <payment-index-row
                    v-slot:rows="slotRow"
                    v-bind="slotRow"
                    :selectable="false"
                  />
                </template>
              </data-table>
            </div>
          </PageTabPanel>
        </PageTabPanels>
      </PageTabGroup>
    </div>
    <!-- END Order tabs -->
  </div>
</template>

<script setup>
import { PageTabGroup, PageTabList, PageTab, PageTabPanels, PageTabPanel } from '@/Components/PageTabs'
</script>

<script>
import { Switch } from '@headlessui/vue'
import { Menu, MenuButton, MenuItem, MenuItems, Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import {
  ArchiveIcon,
  ArrowCircleRightIcon,
  ChevronDownIcon,
  DuplicateIcon,
  HeartIcon,
  PencilAltIcon,
  TrashIcon,
  UserAddIcon
} from '@heroicons/vue/solid'
import { QrcodeIcon } from '@heroicons/vue/outline'
import { ChevronUpIcon, ArrowSmDownIcon, ArrowSmUpIcon } from '@heroicons/vue/solid'
import DataTable from '@/Components/Table/DataTable'
import OrderItemIndexRow from '@/Pages/Orders/Components/OrderItemIndexRow'
import PaymentIndexRow from '@/Pages/Orders/Components/PaymentIndexRow'
import DeliveryInfo from '@/Pages/Orders/Components/DeliveryInfo'
import _date from '@/Filters/Date'
import _datetime from '@/Filters/DateTime'
import _dollars from '@/Filters/Dollars'

export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ArchiveIcon,
    ArrowCircleRightIcon,
    ChevronDownIcon,
    DuplicateIcon,
    HeartIcon,
    PencilAltIcon,
    TrashIcon,
    UserAddIcon,
    QrcodeIcon,
    Switch,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    ChevronUpIcon,
    ArrowSmDownIcon,
    ArrowSmUpIcon,
    DataTable,
    OrderItemIndexRow,
    PaymentIndexRow,
    DeliveryInfo
  },

  props: {
    order: {
      type: Object,
      required: true
    },
    wooCommerceUrl: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      stats: []
    }
  },

  created() {
    this.stats.push({ name: 'Total', stat: _dollars(this.order.total || 0) })
    this.stats.push({ name: 'Items', stat: this.order.items.length })
    // this.stats.push({ name: 'Paid', stat: _dollars(this.order.total_payment || 0) });
  },

  computed: {
    wooCommerceGotoUrl() {
      if (!this.wooCommerceUrl || !this.order.reference_number) {
        return
      }

      return `${this.wooCommerceUrl}/wp-admin/post.php?post=${this.order.reference_number}&action=edit`
    }
  },

  methods: {
    _date,
    _datetime,
    _dollars,
    gotoWooCommerce() {
      if (!this.wooCommerceGotoUrl) {
        return
      }

      window.open(this.wooCommerceGotoUrl, '_blank')
    }
  }
}
</script>
